import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { ContentSecurityPolicy } from '@portal-core/sites/models/content-security-policy.model';

@CollectionStateSelectors({
  stateType: ContentSecurityPolicyState
})
@State<ContentSecurityPolicyState>({
  name: ContentSecurityPolicyState.source,
})
@Service({ autoProvided: false })
export class ContentSecurityPolicyState extends CollectionStateBase {
  static override source = 'ContentSecurityPolicy';
  getSource(): string {
    return ContentSecurityPolicyState.source;
  }
}

@Service()
export class ContentSecurityPolicyDataService extends CollectionDataServiceBase<ContentSecurityPolicy> {
  protected readonly stateType = ContentSecurityPolicyState;
}
